import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, of } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlattener } from '@angular/material/tree';



export class ArlTreeDataSource<T, F, K = F> extends DataSource<F> {
    private readonly _flattenedData = new BehaviorSubject<F[]>([]);

    _treeFlattener: MatTreeFlattener<T, F, K>;

    get data() {
        return this._data.value;
    }
    set data(value: T[]) {
        this._data.next(value);
        this._flattenedData.next(this._treeFlattener.flattenNodes(this.data));
        this._treeControl.dataNodes = this._flattenedData.value;
    }
    private readonly _data = new BehaviorSubject<T[]>([]);

    constructor(
        private _treeControl: FlatTreeControl<F, K>,
        // private _treeFlattener: MatTreeFlattener<T, F, K>,
        // initialData?: T[],
    ) {
        super();

        // if (initialData) {
        //     // Assign the data through the constructor to ensure that all of the logic is executed.
        //     this.data = initialData;
        // }
    }

    connect(collectionViewer: CollectionViewer): Observable<F[]> {
        const expanded = this._treeFlattener.expandFlattenedNodes(
            this._flattenedData.value,
            this._treeControl
        );

        return of(expanded);
    }


    disconnect() {
        // no op
    }
    // private _data: Array<T&{expanded?: boolean}>;
    //
    // constructor(private _treeControl: FlatTreeControl<F, K>, _treeFlattener: MatTreeFlattener<T, F, K>, initialData?: T[]) {
    //     super();
    //     this._data = initialData;
    // }
    // connect(collectionViewer: CollectionViewer): Observable<F[]> {
    //     return this._treeControl.dataNodes;
    // }
    //
    // disconnect(collectionViewer: CollectionViewer): void {
    // }

}
